import { operatorsForCountry } from "@/lib/constants";
import { findCountryByCode } from "@/lib/countries";
import { cn } from "@/lib/utils";

interface Props {
  /** ISO alpha-2 du pays du téléphone (ex. "SN", "CI") */
  countryCode: string;
  value: string | null;
  onChange: (operatorId: string) => void;
}

export function OperatorPicker({ countryCode, value, onChange }: Props) {
  const operators = operatorsForCountry(countryCode);
  const country = findCountryByCode(countryCode);

  if (operators.length === 0) {
    return (
      <div className="rounded-xl border border-warning/30 bg-warning/[0.06] px-3.5 py-3 text-xs text-warning">
        Aucun opérateur disponible pour <strong>{country?.name ?? countryCode}</strong>.
        Change le pays du numéro pour voir les opérateurs supportés.
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 gap-2">
      {operators.map((op) => {
        const active = value === op.id;
        return (
          <button
            key={op.id}
            type="button"
            onClick={() => onChange(op.id)}
            className={cn(
              "flex items-center gap-2.5 rounded-xl border bg-card px-3 py-2.5 transition-all duration-180 text-left",
              active
                ? "border-primary/50 bg-primary/[0.05] ring-1 ring-primary/30"
                : "border-white/[0.06] hover:border-white/[0.12] hover:bg-white/[0.02]"
            )}
          >
            <div className={cn("size-9 rounded-lg flex items-center justify-center text-lg shrink-0", op.color, active && "ring-2 ring-primary/30")}>
              {op.emoji}
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-semibold truncate">{op.name}</p>
              <p className="text-2xs text-muted-foreground">{country?.flag} {country?.name ?? op.country}</p>
            </div>
          </button>
        );
      })}
    </div>
  );
}
